export class SomethingHappenedError extends Error {}
